import { Component, OnInit, ViewChild, Inject, ElementRef, Output, Input, EventEmitter } from '@angular/core';
import { RequestService } from '../services/request.service';
import { ActionsService } from '../services/actions.service';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { DateAdapter } from '@angular/material/core';
import { TicketSystemService } from '../services/ticket-system.service';
import { MachineService } from '../services/machine.service';
import { IndicatorService } from '../services/indicator.service';



export interface Identification {
  unique_number: string;
}

export interface Tickets {
  id: number;
  reqNumber: number;
  methodName: string;
  machineName: string;
  status: string;
  indicatorName: string;
  employee: string;
  created_at: string;
}

export interface Results {
  resp: any;
  result1: string;
  result2: string;
  result3: string;
  final_result: string;
  protocol_id:number;
}

@Component({
  selector: 'app-ticket-system',
  templateUrl: './ticket-system.component.html',
  styleUrls: ['./ticket-system.component.css']
})
export class TicketSystemComponent implements OnInit {
  requests: any;
  add: boolean;
  edit: boolean;
  delete: boolean;
  columns: any;
  columnsToDisplay: any;
  displayedColumns: any;
  dataSource: any = [];
  selection: any;
  identify: boolean = false;
  machines: any;
  unique_number: any;
  private paginator: MatPaginator;
  private sort: MatSort;
  //filter
  reference_number: string;
  status: number;
  machine_id: number;
  name: string;
  indicators:any;
  indicator_id:number;




  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  @ViewChild('unique_id') unique_id: ElementRef;

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }


  constructor(private requestService: RequestService,
    public dialog: MatDialog, private ticketService: TicketSystemService,
    private actionService: ActionsService,
    public snackBar: MatSnackBar,
    private indicatorService: IndicatorService,
    private machineService: MachineService) {
    this.getMachines();
    this.getIndicators();
    this.getActions();
  }
  public loading = false;
  ngOnInit() {
    this.reference_number = '';
      this.status = -1;
      this.machine_id = -1;
      this.name = '';
  }

  ngAfterViewInit() {
    setTimeout(() => this.unique_id.nativeElement.focus());
  }

  getIndicators(){
    this.indicatorService.getIndicators().subscribe(data => {
      this.indicators = data
    });

    return this.indicators;
  }

  newIdentification() {

    this.identify = false;
    this.unique_number = '';
    setTimeout(() => this.unique_id.nativeElement.focus(), 300);
  }


  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }

  getMachines() {
    this.machineService.getMachines().subscribe(data => {
      this.machines = data
    });

    return this.machines;
  }

  getRequest() {
    var params = {
      reference_number: this.reference_number,
      status: this.status,
      machine_id: this.machine_id,
      name: this.name,
      unique_number: this.unique_number,
      indicator_id:this.indicator_id
    }

    this.ticketService.getAllTickets(params).subscribe(resp => {
      this.requests = resp;
      this.identify = true;
      this.displayedColumns = ['id', 'reqNumber', 'created_at', 'indicatorName', 'methodName', 'machineName', 'status', 'employee', 'actions'];
      this.columnsToDisplay = this.displayedColumns.slice();
      this.dataSource = new MatTableDataSource<Tickets>(this.requests);
      this.dataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'created_at': return new Date(item.created_at.date).getTime();
          default: return item[property];
        }
      };
      this.selection = new SelectionModel<Tickets>(true, []);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    })

    return this.requests;
  }


  


  getActions() {
    this.actionService.moduleAction(1).subscribe(data => {
      this.add = data.add_action;
      this.edit = data.edit_action;
      this.delete = data.delete_action;
    });
  }



  openIdentificationDialog(id, type): void {

    const dialogRef = this.dialog.open(Identification, {
      width: '600px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loading = true;
      if (result != undefined && this.unique_number == result.unique_number) {
        if (result != undefined) {
          var data = {
            id: id,
            unique_number: result.unique_number
          }
          this.ticketService.checkTechnicianId(data).subscribe(resp => {
            if (resp) {
              if (type == 'result') {
                this.openResultsDialog(id);
                this.loading = false;
              } else if (type == 'take') {
                this.ticketService.updateTicket(data, id).subscribe(resp2 => {
                  this.getRequest();
                  this.loading = false;
                  this.openSnackBar('Показателя е поет за изследване ', null);

                })

              }

            } else {
              this.loading = false;
              this.openSnackBar('Грешен идентификационнен номер ', null);
            }
          });
        }
      } else {
        this.loading = true;
        this.openSnackBar('Грешен идентификационнен номер ', null);
      }

    });
  }

  openResultsDialog(id): void {
    this.ticketService.editTicket(id).subscribe(resp => {
      console.log(resp);
      const dialogRef = this.dialog.open(Results, {
        width: '600px',
        data: { data: resp, starting_data: resp.starting_data, result1: resp.result1, result2: resp.result2, result3: resp.result3, final_result: resp.final_result }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          var data = {
            id: id,
            technician_id: resp.technician_id,
            starting_data: result.starting_data,
            result1: result.result1,
            result2: result.result2,
            result3: result.result3,
            final_result: result.final_result
          }
          this.ticketService.saveTicket(data).subscribe(data => {
            this.getRequest();
          })

        }
      });
    });

  }



}

@Component({
  selector: 'identification',
  templateUrl: 'identification.html',
})
export class Identification {

  constructor(public dialogRef: MatDialogRef<Identification>,
    @Inject(MAT_DIALOG_DATA) public data: Identification) { }

  closeModal(): void {
    this.dialogRef.close();
  }

  identifyTech(data) {
    this.dialogRef.close(data);
  }

}


@Component({
  selector: 'results',
  templateUrl: 'results.html',
})
export class Results {

  constructor(public dialogRef: MatDialogRef<Results>,
    public dialog: MatDialog,
    public ticketService: TicketSystemService,
    @Inject(MAT_DIALOG_DATA) public data: Results) {
    console.log(data);
  }

  saveResult(data): void {
    const dialogRef2 = this.dialog.open(ResultConfirm, {
      width: '250px',
      data: { data }
    });

    dialogRef2.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.dialogRef.close(result);
      }

    });
  }


  closeModal(): void {
    this.dialogRef.close();
  }

}

@Component({
  selector: 'resultConfirm',
  templateUrl: 'resultConfirm.html',
})
export class ResultConfirm {

  constructor(public dialogRef: MatDialogRef<Results>,
    @Inject(MAT_DIALOG_DATA) public data: Results) {
    console.log(data);
  }

  saveResult(result): void {
    this.dialogRef.close(result);
  }

  closeModal(): void {
    this.dialogRef.close();
  }

}


